import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.19 8.06h-1.84V4a.77.77 0 0 0-.29-.59l-2.59-2a.75.75 0 0 0-1 0L4.92 3.65a.77.77 0 0 0-.26.57v1.11H2.82a.74.74 0 0 0-.75.75V14a.75.75 0 0 0 .75.75h10.37a.75.75 0 0 0 .75-.75V8.81a.74.74 0 0 0-.75-.75Zm-7.13 4h-1.3V10.8h1.3Zm0-2.69h-1.3V8.11h1.3Zm2.59 2.73H7.36v-1.3h1.29Zm0-2.69H7.36v-1.3h1.29Zm0-2.68H7.36v-1.3h1.29Zm2.6 5.37H10v-1.3h1.3Z';
const draw24px =
  'M9,18V16H7v2Zm0-4.15v-2H7v2ZM11,7.7v2h2v-2Zm0,4.14v2h2v-2ZM15,16v2h2V16Zm-2,2V16H11v2Zm7.75-5.08v8a.75.75,0,0,1-.75.75H4a.74.74,0,0,1-.75-.75V8.7A.75.75,0,0,1,4,8H7.25V5.84a.73.73,0,0,1,.26-.57l4-3.43a.75.75,0,0,1,1,0l4,3.14a.75.75,0,0,1,.29.59v6.61H20A.76.76,0,0,1,20.75,12.91Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'buildingFilled')) as IconWithRender;

BuildingFilledIcon.displayName = 'BuildingFilledIcon';
BuildingFilledIcon.propTypes = Icon.propTypes;
BuildingFilledIcon.renderIcon = (props) => <BuildingFilledIcon {...props} />;
export default BuildingFilledIcon;
